// Copyright (c) 2021 WiseTime. All rights reserved.

import { timer, Observable, of, takeUntil, repeat } from "rxjs"
import { Action } from "redux"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { from, notificationService } from "../../../app/rpc"
import {
  App,
  ListNotificationsRequestSchema,
  ListNotificationsResponse,
} from "../../../generated/wisetime/user/notification/v4/notification_pb"
import { type VisibilityChange, visibilityChange } from "../../../app/visibilityChange"

type ListNotificationsRpc = () => Observable<ListNotificationsResponse>

export const listNotifications = (
  listNotificationsRpc: ListNotificationsRpc,
  visibilityChange: VisibilityChange,
) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listNotifications.match),
      mergeMap(action => {
        const { pageVisible$, pageHidden$ } = visibilityChange()
        return timer(5000, 120_000)
          .pipe(
            mergeMap(() => of(action).pipe(
              mergeMap(listNotificationsRpc),
              mergeMap(response => of(Slice.setNotifications(response.notifications))),
              catchError(_ => of(Actions.listNotificationsFailed())),
            )),
            takeUntil(pageHidden$),
            repeat({ delay: () => pageVisible$ }),
          )
      }),
    )

const listNotificationsRpc = (): Observable<ListNotificationsResponse> =>
  from(() => notificationService.listNotifications(
    create(ListNotificationsRequestSchema, { app: App.WEB_TIMELINE })
  ))

export default listNotifications(listNotificationsRpc, visibilityChange)
